import request from "./http";

class BankRepository
{
    async getAll() {
        const path = "banks";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }
}

export default BankRepository;